import React from 'react';
import { List, ListItem, ListItemIcon, Typography, IconButton } from '@mui/material';
import { Attachment as AttachmentIcon, Close } from '@mui/icons-material';

interface AttachmentsListProps {
  attachments: File[];
  onRemoveAttachment: (index: number) => void;
}

export const AttachmentsList = React.memo(({ attachments, onRemoveAttachment }: AttachmentsListProps) => {
  if (attachments.length === 0) return null;

  return (
    <List sx={{ display: 'flex', gap: (theme) => theme.spacing(1), pb: 2 }}>
      {attachments.map((file: File, index: number) => (
        <ListItem
          sx={{
            gap: 1,
            display: 'flex',
            width: 'fit-content',
            borderRadius: 1,
            backgroundColor: (theme) => theme.palette.background.paper,
            border: (theme) => `1px solid ${theme.palette.divider}`,
            padding: (theme) => theme.spacing(0.5, 0.5, 0.5, 1),
          }}
          key={index}
        >
          <ListItemIcon
            sx={{
              minWidth: 'fit-content',
            }}
          >
            <AttachmentIcon />
          </ListItemIcon>
          <Typography sx={{ flexGrow: 1 }} color="text.primary" variant="subtitle2">
            {file.name}
          </Typography>
          <IconButton size="small" onClick={() => onRemoveAttachment(index)} aria-label={`Remove ${file.name}`}>
            <Close
              sx={{
                width: 20,
                height: 20,
              }}
            />
          </IconButton>
        </ListItem>
      ))}
    </List>
  );
});

AttachmentsList.displayName = 'AttachmentsList';
